import type { Theme } from '../../types/theme';

export const wiredTheme: Theme = {
  id: 'wired',
  name: 'WIRED',
  description: 'Paper-white broadsheet density with custom serif for tech magazine',
  sourceDesignMd: 'https://github.com/nexu-io/open-design/blob/main/design-systems/wired/DESIGN.md',
  visualKeywords: ['paper-white', 'broadsheet', 'serif', 'ink-blue links', 'editorial'],
  colors: {
    background: '#ffffff',
    surface: '#fafafa',
    surfaceElevated: '#fafafa',
    textPrimary: '#111111',
    textSecondary: '#555555',
    textMuted: '#555555',
    border: '#e0e0e0',
    borderSubtle: '#d6d6d6',
    primary: '#1a1aff',
    primaryHover: '#2929ff',
    primaryActive: '#0000e1',
    accent: '#1a1aff',
    onPrimary: '#ffffff',
    success: '#22c55e',
    warning: '#f59e0b',
    error: '#ef4444',
  },
  typography: {
    headingFont: 'Inter, system-ui, sans-serif',
    bodyFont: 'Inter, system-ui, sans-serif',
    monoFont: 'JetBrains Mono, monospace',
    headingWeight: '600',
    bodyWeight: '400',
    letterSpacingHeading: '-0.02em',
    letterSpacingBody: '0',
  },
  radius: {
    button: '6px',
    card: '8px',
    panel: '8px',
    badge: '4px',
    input: '6px',
  },
  shadow: {
    card: '0 1px 3px rgba(0,0,0,0.1)',
    elevated: '0 4px 12px rgba(0,0,0,0.15)',
    button: '0 1px 2px rgba(0,0,0,0.1)',
    none: 'none',
  },
  layout: {
    maxWidth: '1280px',
    sectionSpacing: '80px',
    cardPadding: '24px',
    navHeight: '64px',
  },
  mood: {
    density: 'high',
    tone: 'editorial',
    productFit: [],
    bestFor: [],
    notGoodFor: [],
  },
};
